import { GetLocationByKey } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';

export const Branch = ({
  branch,
  selected,
}: {
  branch: GetLocationByKey;
  selected: boolean;
}) => {
  return (
    <div className={`branch ${selected && 'selected'}`}>
      <h4 className="title">{branch.name}</h4>
      <div className="address">
        <p>
          Address:
          <span>
            {branch.address
              ? ` ${branch.address!!.country}, ${branch.address!!.city}`
              : ' -'}
          </span>
        </p>
      </div>
    </div>
  );
};
